module.exports = __webpack_public_path__ + "img/video-player/down@2x-18bca9fff9e1dd8eaf5cd14f6783c0f1.png";